<template>
  <div
    :id="invoice.id"
    draggable="true"
    class="invoice-item"
    @dragstart="onDragStart"
    @contextmenu.prevent.stop="onRightClick($event, invoice)"
    :class="{'active': isActive, 'red-03': !invoice.is_secure }"
  >
    <div class="invoice-item-content d-flex">
      <div v-if="!hideIcon" class="icon pr-3" :class="{'checked': isSelected }">
        <div class="checkbox-wrapper">
          <b-form-checkbox :checked="isSelected" @change="onChange"></b-form-checkbox>
        </div>
        <span :class="iconClass">{{shorterName}}</span>
      </div>
      <div style="flex-grow: 1" @dblclick="onDbClick(invoice)" @click="onClickItem(invoice)">
        <div class="w-full d-flex justify-content-between">
          <div class="font-weight-bold">
            <span v-if="index">{{index}} - </span>
            {{invoice.invoice_number || invoice.invoice_no}}
          </div>
          <div>
            <i
              v-if="checkValidInvoice"
              class="fad fa-exclamation-triangle mr-1"
              style="--fa-primary-color: #FD2222; --fa-secondary-color: #F4CE35; --fa-secondary-opacity: 1;"
            ></i>
            <img class="mb-1" v-if="invoice.is_secure && !isDraftInvoice" height="18px" src="/images/thue-nha-nuoc.svg" alt="verified icon">
          </div>
        </div>
        <div class="invoice-title">
          <strong>{{displayName}}</strong>
        </div>
        <div class="invoice-number">
          <label v-if="!invoice.is_secure" class="badge">
            <span class="bg-warning">{{$t('invoice.unknownOrigin')}}<i class="fa fa-question ml-1"></i></span>
          </label>
          <span v-if="invoice.tags && invoice.tags.length > 0">
            <label v-for="tag in invoice.tags.slice(0,3)" class="badge">
              <span :style="{ backgroundColor: getTagColor(tag) }">
               {{tag.name | tagName}}
              </span>
            </label>
          </span>
        </div>
        <div v-if="errorInvoices && errorInvoices[invoice.id]" class="invoice-description red">{{errorInvoices[invoice.id]}}</div>
        <div
          class="invoice-type"
          v-if="invoice.invoice_type && (invoice.invoice_type === 'REPLACED' || invoice.invoice_type === 'REPLACE' || invoice.invoice_type === 'MODIFY' || invoice.invoice_type === 'MODIFIED' || invoice.invoice_type === 'CANCELED')"
        >
          <p class="mb-0">
            {{ $t(`invoice.invoiceTypes.${invoice.invoice_type}`) }}
          </p>
        </div>
      </div>
    </div>
    <div class="invoice-item-footer d-flex justify-content-between bg-hover">
      <div>
        <p class="mb-0 invoice-description">
          <span v-if="invoice.releasing_status">{{ $t(`invoice.releasingStatus.${invoice.releasing_status}`) }}</span>
          <span v-else-if="invoice.paid_date">{{$t('invoice.paid')}}: {{invoice.paid_date | formatDate}}</span>
          <span v-else>{{$t('invoice.unpaid')}}</span>
        </p>
        <p class="mb-0 invoice-description">
          <span v-if="!hideInvoiceType">{{invoice.kind_of ? $t('invoice.outcome') : $t('invoice.income')}}:</span>
          {{invoice.issued_date | formatDate}}
        </p>
      </div>
      <p class="invoice-total mb-0">{{$t('app.total')}} {{invoice.total_amount_with_tax | formatNumber }}</p>
    </div>
  </div>
</template>

<script>
import { toShortName } from '@/utils/text';

export default {
  name: 'InvoiceItem',
  props: {
    errorInvoices: Object,
    invoice: Object,
    isSelected: false,
    isActive: false,
    hideIcon: false,
    index: Number,
    hideInvoiceType: false,
    getTagColor: Function,
  },
  data() {
    return {};
  },
  computed: {
    isDraftInvoice() {
      return this.invoice.invoice_type === 'DRAFT' || this.invoice.releasing_status === 'draf';
    },
    displayName() {
      const buyerName = this.invoice.buyer_legal_name || this.invoice.buyer_name || '';
      const sellerName = this.invoice.seller_legal_name || this.invoice.seller_name || '';
      return this.invoice.kind_of ? buyerName : sellerName;
    },
    shorterName() {
      const name = this.displayName;
      return toShortName(name);
    },
    iconClass() {
      const shorterName = this.shorterName;

      if (!shorterName || typeof shorterName !== 'string' || shorterName.length < 2) {
        return '';
      }

      const idx = (shorterName[0].charCodeAt() + shorterName[1].charCodeAt()) % 6;
      return `bg-random-${idx}`;
    },
    checkValidInvoice() {
      if (!this.invoice.customer_invalid_data) return false;
      const {
        correct_address,
        correct_company_name,
        warning,
        tax_risk,
        company_name_error,
        address_error,
      } = this.invoice.customer_invalid_data;
      // eslint-disable-next-line camelcase
      const isNoneChecked = (correct_address === 'N/A' && correct_company_name === 'N/A') || (!correct_address && !correct_company_name);
      if (isNoneChecked) {
        return false;
      }
      // eslint-disable-next-line camelcase
      return warning || tax_risk || company_name_error || address_error;
    },
  },
  methods: {
    onDbClick(invoice) {
      this.$emit('on-db-click', invoice);
    },
    onClickItem(invoice) {
      this.$emit('on-click', invoice);
    },
    onRightClick($event, invoice) {
      this.$emit('on-right-click', $event, invoice);
    },
    onChange(value) {
      this.$emit('on-change', {
        id: this.invoice.id,
        isSelected: value,
        invoice_number: this.invoice.invoice_number,
        total_amount_with_tax: this.invoice.total_amount_with_tax,
        total_amount_without_tax: this.invoice.total_amount_without_tax,
        tags: this.invoice.tags
      });
    },
    onDragStart($event) {
      $event.dataTransfer.setData('INVOICE_ID', $event.target.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-item.vue